var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_vm._t("title"),_c('div',{staticClass:"page-container__body"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }